<template>
  <div class="store-line-card">
    <v-card flat min-height="152" color="primary">
      <div class="card-content">
        <div class="card-row">
          <div class="text-title">
            Forecast
          </div>
        </div>
        <div class="card-row">
          <div class="text-normal">
            For Today

          </div>
          <div class="text-large">
            <span v-if="loading">
              <v-progress-circular v-if="loading" size="20" width="2"
                                   indeterminate
                                   color="white"
              ></v-progress-circular>
            </span>
            <span v-else>{{coming_today}}</span>
          </div>
        </div>
        <div class="card-row">
          <div class="text-normal">
            In 30 Minutes

          </div>
          <div class="text-large">
              <span v-if="loading">
                <v-progress-circular v-if="loading" size="20" width="2"
                                     indeterminate
                                     color="white"
                ></v-progress-circular>
              </span>
            <span v-else>{{coming_next_30_minutes}}</span>
          </div>
        </div>
      </div>
      <img class="background-logo" src="/static/dashboard_card.png" alt="logo">
    </v-card>
  </div>
</template>

<script>

  const moment = require('moment-timezone')

  export default {
    name: "DashboardLineCard",
    props: ['coming_next_30_minutes', 'coming_today', 'loading']
  }
</script>

<style lang="scss" scoped>
  .store-line-card {
    width: 78%;
    place-self: center;

    .v-card {
      overflow: hidden;
      border-radius: 14px !important;
      position: relative;

      .background-logo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 1;
      }

      .card-content {
        text-align: -webkit-center;
        padding: 1.4rem;
        color: white;

        .card-row {
          display: grid;
          grid-template-columns: 1fr 1fr;

          .text-title {
            font-weight: 600;
            text-align: left;
            font-size: 24px;
            letter-spacing: 0.5px;
          }

          .text-normal {
            align-self: center;
            font-weight: 400;
            text-align: left;
            font-size: 18px;
            letter-spacing: 0.2px;
          }

          .text-small {
            font-weight: 300;

            font-size: 12px;
            letter-spacing: 0.09px;
          }

          .text-large {
            font-weight: 600;
            letter-spacing: 0.27px;
            font-size: 36px;
            text-align: right;
          }
        }


      }
    }


  }
</style>



// WEBPACK FOOTER //
// src/Elements/DashboardLineCard.vue